export const types = {
    album: 'Album',
    artist: 'Artist',
    audioClip: 'AudioClip',
    category: 'Category',
    container: 'Container',
    link: 'link',
    program: 'Program',
    prompt: 'Prompt',
    station: 'Station',
    topic: 'Topic',
    user: 'User',
    region: 'Region',
};
export const guideIdPrefixTypeMap = {
    a: types.category,
    c: types.category,
    d: types.album,
    g: types.category,
    i: types.audioClip,
    m: types.artist,
    p: types.program,
    r: types.region,
    s: types.station,
    t: types.topic,
    u: types.user,
    v: types.category,
};
